import { useQuery } from '@tanstack/react-query';
import { getAllTimezones } from '@uplift/api';


export const useAllTimezonesQuery = () => useQuery({
  queryKey: [ 'all-timezones' ],
  queryFn: async () => {
    const response = await getAllTimezones();

    return response.data;
  }
});


export const useAllTimezones = () => {
  const { data } = useAllTimezonesQuery();

  return data ?? [];
};
